<template>
  <div>
    <tabs class="versions-tabs" ref="tab-sections" :value="(GrantForm.isOnARevisionTab ? $t('medium_grant.revision_tab__revised_version') : $t('medium_grant.revision_tab__original_version'))" @activate-tab="activateTab" type="info" square>

        <grant-sub-wizard nickname="technical">
          <grant-sub-wizard-tab :before-change="() => validateStep('step1')">
            <page1 ref="step1"></page1>
          </grant-sub-wizard-tab>
        </grant-sub-wizard>
    </tabs>
  </div>
</template>

<script>
  import Page1 from './Page1';

  import {TabPane, Tabs} from 'src/components';
  import {GrantSubWizard, GrantSubWizardTab} from '@/components';
  import {GrantForm} from "@/services";

  export default {
    data() {
      return {
        GrantForm
      }
    },
    components: {
      Tabs,
      TabPane,
      GrantForm,
      GrantSubWizard,
      GrantSubWizardTab,
      Page1,
    },
    methods: {
      activateTab(ev) {
        GrantForm.isOnARevisionTab = (ev.id === 'revised');
      },
      validateStep(ref) {
        return (this.$refs[ref].validate) ? this.$refs[ref].validate() : true;
      }
    }
  }
</script>

<style>
  textarea
  {
    min-height: 50px;
  }
</style>
